<template>
<v-container>
  <v-layout justify-center>
        <v-dialog v-model="insertDialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">{{ $t('key359') }}</v-card-title>
            <v-card-text>
            <v-text-field v-model="email" label="Email"/>
            </v-card-text>
            <v-card-text v-html="mailError" style="color:red"></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn  color="blue darken-1" text @click="AggiungiMail" >AGGIUNGI</v-btn>
              <v-btn  color="blue darken-1" text @click="insertDialog = false; mailError = ''; email = '';" >CHIUDI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-layout justify-center style="align-items: center">
        <v-flex xs12 sm12>
          <v-card>
            <v-card-title style="font-size: 2em;"><h1>{{ $t('key329') }}!</h1></v-card-title>
            <v-form v-model="valid">
              <v-card-text>
                <v-flex sm12>
                  <p>1)	L'indirizzo del nuovo portale clienti è cambiato. Ora dovrai accedere a https://clienti.arcospedizioni.it/#/ , salvalo nei tuoi preferiti. </p>
                </v-flex>
                <v-flex sm12>
                  <p>2)	Per collegarti dovrai usare:</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;- L’Indirizzo mail che hai inserito nel modulo precedente</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;- La Password che hai inserito nel modulo precedente</p>
                </v-flex>
                <v-flex sm12>
                  <p>3)	Se altri utenti/colleghi accedevano al Portale Clienti con le tue credenziali precedenti, inserisci qui i loro indirizzi di posta elettronica:</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;riceveranno una mail per registrarsi al nuovo Portale Clienti e saranno quindi completamente autonomi.</p>
                </v-flex>
                <v-flex sm6 md6>
                  <v-data-table v-bind:headers="headerEmail" v-bind:items="AccountCollegati" >
                  <template slot="items" slot-scope="props">
                    <tr>
                        <td class="text-xs-left">{{ props.item.text }}</td>
                        <td><v-icon @click="DeleteMail(props.item)">delete</v-icon></td>
                    </tr>
                  </template>
                  <template
                    slot="pageText"
                    slot-scope="{ pageStart, pageStop }"
                  >From {{ pageStart }} to {{ pageStop }}</template>
                </v-data-table>
                </v-flex>
                <v-card-actions>
                  <v-flex sm12>
                    <v-btn @click="insertDialog = true">Aggiungi email</v-btn>
                  </v-flex>
                  <v-flex sm12>
                    </v-flex>
                </v-card-actions>
                <v-flex sm12>
                  <p>4)	Le vecchie credenziali di accesso non sono più attive</p>
                  </v-flex>
                 <v-flex sm12>
                   <p> 5)	Il vecchio Portale Clienti non è più attivo</p>
                   <p>&nbsp;&nbsp;&nbsp;&nbsp;Se utilizzi Internet Explorer ti ricordiamo che tale browser non è più supportato e aggiornato e quindi non consente l’accesso.</p>
                   <p>&nbsp;&nbsp;&nbsp;&nbsp;Potrai usare Chrome, Firefox, Edge o qualsiasi altro browser aggiornato.</p>
                   <p>&nbsp;&nbsp;&nbsp;&nbsp;Buon lavoro!</p>
                  </v-flex> 
                
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="InviaMail">CONFERMA</v-btn>
                </v-card-actions>
                
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
export default {
  data() {
    return {
      codice: 0,
      mailInvio: "",
      idUtente: 0,
      idGruppo: 0,
      message: "",
      AccountCollegati: [],
      insertDialog: false,
      email: "",
      mailError: "",
      headerEmail: [
        { text: "Email", align: "left", value: "text" },]
    };
  },
  mounted() {
    this.codice = this.$route.params.codice;
    this.idUtente = this.$route.params.idUtente;
    this.idGruppo = this.$route.params.idGruppo;
    this.mailInvio = this.$route.params.mailInvio;
  },
  methods: {
    
    AggiungiMail(){
      if(this.email == null || this.email == undefined)
        this.email = "";

      var regexEmail = /^(([^\'<>()\[\]\\.,;:\s@"]+(\.[^\'<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
      var resultMail = this.email.trim().match(regexEmail);
      if(resultMail === null){
        this.mailError += "- L'INDIRIZZO EMAIL " + this.email + " NON RISULTA VALIDO E NON PUO' ESSERE AGGIUNTO </br>";
      }
      else{
        this.AccountCollegati.push({text: this.email});
        this.mailError = "";
        this.insertDialog = false;
        this.email = "";
      }
    },
    DeleteMail(item){
      const index = this.AccountCollegati.indexOf(item)
      this.AccountCollegati.splice(index, 1)
    },
    InviaMail(){
      var elencoMail = []
      this.AccountCollegati.forEach(e=>{
        elencoMail.push(e.text);
      })
      axios.post(this.$store.state.servicePath + '/api/Login/SendMailRegistrazione',{
        ElencoMail: elencoMail,
        idGruppo: this.idGruppo,
        idUtente: this.idUtente,
        codice: this.codice,
        mailInvio: this.mailInvio
      })
      .then(res=>{
        this.$router.push({ path: `/` });
      })
    }
  }
};
</script>
<style scoped>
  p{
    font-size: 20px;
    font-weight: bold;
  }
</style>